import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface SuzCredentials {
	isDefault: boolean,
	login: string,
	password: string,
}

export class SuzCredentialsQuery extends Query<SuzCredentials> { }

export class SuzCredentialsQueryHandlerBase implements QueryHandler<SuzCredentialsQuery, SuzCredentials> {
	private static Url = TaggedUrl.join('suz', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(_: SuzCredentialsQuery): Promise<SuzCredentials> {
		const { data } = await this.http.get<SuzCredentials>(SuzCredentialsQueryHandlerBase.Url);
		return data;
	}
}
